import React from 'react'
import PropTypes from "prop-types";
import {Col, Dropdown, Row} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faSort} from "@fortawesome/free-solid-svg-icons";
import label from "enqc-utilities/src/label/Label";


export default class TableSortOption extends React.Component{

    state = {}
    constructor(props) {
        super(props);
        let defaultSortOption = {
            label:label.SelectOrder
        }
        let sortOptions = props.sortOptions?props.sortOptions:Array()
        sortOptions.unshift(defaultSortOption)
        this.state = {
            sortOptions:sortOptions,
            sortOption:props.sortOption&&props.sortOption.label?props.sortOption:defaultSortOption,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps != this.props) {
            let sortOptions = this.props.sortOptions?this.props.sortOptions:Array()
            let defaultSortOption = {
                label:label.SelectOrder
            }
            sortOptions.unshift(defaultSortOption)
            let sortOption = this.props.sortOption&&this.props.sortOption.label?this.props.sortOption:defaultSortOption
            this.setState({sortOption, sortOptions})
        }

    }

    render() {
        let {sortOption, sortOptions} = this.state
        let {placeholder, onSelect, onReset} = this.props
        if(!sortOptions){
            sortOptions = Array()
        }
        return (
            <React.Fragment>
                <Dropdown size="sm" drop="left">
                    <Dropdown.Toggle
                        size="sm"
                        variant="outline-success" id="dropdown-basic">
                        {sortOption.label}&nbsp;&nbsp;<FontAwesomeIcon icon={faSort}/>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="p-0 fs-7">
                        {sortOptions.map((item, index)=>(
                            <>
                                <Dropdown.Item className="px-2 py-2 fs-7" href="#" onClick={event => {
                                    if(index===0){
                                        if(onReset){
                                            onReset()
                                        }
                                    }else{
                                        this.setState({sortOption: item},() => {
                                            if(onSelect){
                                                onSelect(item)
                                            }
                                        })
                                    }
                                }}>
                                    <Row>
                                        <Col>
                                            {item.label}
                                        </Col>
                                        <Col className="text-right">
                                            {
                                                sortOption.label===item.label&&(
                                                    <FontAwesomeIcon size="sm" icon={faCheck}/>
                                                )
                                            }
                                            {/*<MyImage src={ApplicationIcons.Icons.che} style={{width:'18px'}} />*/}
                                        </Col>
                                    </Row>
                                </Dropdown.Item>
                                <Dropdown.Divider className="m-0"/>
                            </>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </React.Fragment>
        );
    }

    // render() {
    //     let {sortOption, sortOptions} = this.state
    //     let {placeholder, onSelect, onReset} = this.props
    //     if(!sortOptions){
    //         sortOptions = Array()
    //     }
    //     return (
    //         <div className="clickable-input" onClick={event => {
    //             document.getElementById("dropdown")
    //                 .getElementsByClassName("dropdown-toggle")[0].click()
    //         }}>
    //             <Dropdown id={"dropdown"} as={ButtonGroup}>
    //                 {label.SortBy}&nbsp;&nbsp;
    //                 <Dropdown.Toggle split as={Button} variant="link" className="text-dark m-0 p-0">
    //             <span className="icon icon-sm icon-gray">
    //               <FontAwesomeIcon icon={faSort}/>
    //             </span>
    //                 </Dropdown.Toggle>
    //                 <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-right">
    //                     <Dropdown.Item
    //                         className="fw-bold text-dark"
    //                         onClick={event => {
    //                             this.setState({sortOption: {}},() => {
    //                                 if(onReset){
    //                                     onReset()
    //                                 }
    //                             })
    //                         }}>
    //                         {placeholder?placeholder:label.Reset}
    //                     </Dropdown.Item>
    //                     {sortOptions.map((item)=>{
    //                         return (
    //                             <Dropdown.Item
    //                                 className="fw-bold"
    //                                 onClick={event => {
    //                                     this.setState({sortOption: item},() => {
    //                                         if(onSelect){
    //                                             onSelect(item)
    //                                         }
    //                                     })
    //                                 }}>
    //                                 {item.label} <FontAwesomeIcon style={{visibility:(sortOption.label===item.label?'unset':'hidden')}} icon={faCheck}/>
    //                             </Dropdown.Item>
    //                         )
    //                     })}
    //                 </Dropdown.Menu>
    //             </Dropdown>
    //         </div>
    //     );
    // }

}
TableSortOption.propTypes = {
    placeholder:PropTypes.string,
    sortOptions:PropTypes.array.isRequired,
    sortOption:PropTypes.object.isRequired,
    onSelect:PropTypes.func.isRequired,
    onReset:PropTypes.func.isRequired
}